function storyIsPublished(story) {
  return Boolean(story && story.isPublished);
}

function passesPublishGate({ onRenderSurface = false, story = null, hasBoundStory = true } = {}) {
  if (!onRenderSurface || !hasBoundStory) {
    return true;
  }
  return storyIsPublished(story);
}

module.exports = { storyIsPublished, passesPublishGate };
module.exports.default = { storyIsPublished, passesPublishGate };
